import { Button, FormControl, Grid, TextField } from '@material-ui/core';
import translation from 'locales/translation';
import React, { useCallback, useMemo, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { modalsActionsClose } from '../../../../store/modules/ModalsActions';
import { ModalsActionsClose } from '../../../../store/modules/ModalsActionTypes';
import { IModalProps } from '../../../../store/modules/ModalsReducer';
import GenericModal, { IGenericModalProps } from '../GenericModal/GenericModal';
import { useStyles } from './styles';
export interface ICadastrarTextoAssociadoModalGenericProps
  extends IGenericModalProps {
  idParametro: number;
  texto: string;
  urlVideo: string;
  key: string;
  title: string;
  onConfirm: Function;
}

const URL_REGEX = /^(ftp|https?):\/\/[^\s"]+$/;

export interface ICadastrarTextoAssociadoModal extends IModalProps {
  genericProps: ICadastrarTextoAssociadoModalGenericProps;
  modalsActionsClose: (key: string) => ModalsActionsClose;
}

const mapDispatchToProps = (dispatch: Dispatch<any>) =>
  bindActionCreators(
    {
      modalsActionsClose,
    },
    dispatch
  );

const CadastrarTextoAssociadoModal = ({
  genericProps,
  open,
}: ICadastrarTextoAssociadoModal) => {
  const classes = useStyles();
  const [linkVideo, setLinkVideo] = useState(genericProps.urlVideo);
  const [textoAssociado, setTextoAssociado] = useState(genericProps.texto);
  const linkVideoWasTouched = useMemo(
    () => linkVideo !== null && linkVideo !== undefined,
    [linkVideo]
  );
  const dispatchAction = useDispatch();

  const canSubmit = useMemo(() => {
    if (linkVideo === null || textoAssociado === null) return false;
    if (!linkVideo.trim() || !textoAssociado.trim()) return false;
    if (!URL_REGEX.test(linkVideo)) return false;
    // if (!isYouTubeUrl(linkVideo)) return false;
    return true;
  }, [linkVideo, textoAssociado]);

  const urlIsValid = useMemo(() => {
    if (!linkVideoWasTouched) return true;
    if (!linkVideo.trim()) return false;
    if (!URL_REGEX.test(linkVideo!)) return false;
    // if (!isYouTubeUrl(linkVideo!)) return false;
    return true;
  }, [linkVideo, linkVideoWasTouched]);

  const handleLinkVideoChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const opcao = event.target.value as string;
    setLinkVideo(opcao);
  };

  const handleTextoAssociadoChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const opcao = event.target.value as string;
    setTextoAssociado(opcao);
  };

  const toClose = useCallback((): void => {
    if (genericProps && genericProps.key) {
      dispatchAction(modalsActionsClose(genericProps.key));
    }
  }, [genericProps, dispatchAction]);

  const toConfirm = useCallback(() => {
    const body = {
      idParametro: genericProps.idParametro,
      texto: textoAssociado,
      urlVideo: linkVideo,
    };
    genericProps.onConfirm(body);
    toClose();
  }, [toClose, genericProps, linkVideo, textoAssociado]);

  return (
    <GenericModal
      open={open ?? false}
      title={genericProps.title}
      content={
        <Grid container className={classes.root}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <FormControl className={classes.formControl}>
              <TextField
                label={translation.Parâmetros.modalConfigurarTexto.linkVideo}
                className={classes.textItens}
                value={linkVideo}
                onChange={handleLinkVideoChange}
                maxRows={3}
                multiline
                inputProps={{
                  maxLength: 200,
                }}
                helperText={
                  translation.Parâmetros.modalConfigurarTexto.linkValido
                }
                error={!urlIsValid}
              />
              <TextField
                label={translation.Parâmetros.modalConfigurarTexto.texto}
                className={classes.textItens}
                value={textoAssociado}
                onChange={handleTextoAssociadoChange}
                maxRows={14}
                multiline
                inputProps={{
                  maxLength: 650,
                }}
                helperText={`${
                  textoAssociado !== null ? textoAssociado.length : '0'
                }/${650}`}
              />
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            className={classes.confirmButtom}
          >
            <Button
              variant='contained'
              color='primary'
              onClick={() => toConfirm()}
              disabled={!canSubmit}
            >
              {translation.Parâmetros.modalConfigurarTexto.confirmar}
            </Button>
          </Grid>
        </Grid>
      }
      genericProps={{
        maxWidth: 'sm',
        onClose: toClose,
      }}
    />
  );
};

export default connect(null, mapDispatchToProps)(CadastrarTextoAssociadoModal);
